import "rc-calendar/assets/index.css";
import React, { useState } from "react";
import Calendar from "rc-calendar";
import DatePicker from "rc-calendar/lib/Picker";
import enUS from "rc-calendar/lib/locale/es_ES";
import { Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import DateRange from "@material-ui/icons/DateRange";

import moment from "moment";
import "moment/locale/es";

const format = "WW-YYYY";
const now = moment();

const useStyles = makeStyles(theme => ({
  hover: {
    "&:hover": {
      cursor: "pointer"
    }
  }
}));

function CalendarComponent({ getWeek }) {
  const [state, setState] = useState({ value: undefined, open: false });
  const onChange = value => {
    getWeek(value);
    setState(prevState => ({ ...prevState, value }));
  };

  const onOpenChange = open => {
    setState(prevState => ({ ...prevState, open }));
  };

  const dateRender = current => {
    const selectedValue = state.value;
    if (
      selectedValue &&
      current.year() === selectedValue.year() &&
      current.week() === selectedValue.week()
    ) {
      return (
        <div className="rc-calendar-selected-day">
          <div className="rc-calendar-date">{current.date()}</div>
        </div>
      );
    }
    return <div className="rc-calendar-date">{current.date()}</div>;
  };

  const classes = useStyles();
  const calendar = (
    <Calendar
      className="week-calendar"
      showWeekNumber
      dateRender={dateRender}
      locale={enUS}
      format={format}
      style={{ zIndex: 1000 }}
      defaultValue={now}
      showDateInput
    />
  );
  return (
    <Grid container justify="flex-start" alignItems="center" spacing={3}>
      <Grid item>
        {state.value ? (
          <Typography variant="h5" color="secondary">{`Monday ${state.value
            .isoWeekday(1)
            .day(1)
            .format("DD")} to Sunday ${state.value
            .isoWeekday(1)
            .day(7)
            .format("DD")} `}</Typography>
        ) : (
          <Typography
            variant="h5"
            color="secondary"
            onClick={() => onOpenChange(!state.open)}
            classes={{ h5: classes.hover }}
          >
            Select a Week
          </Typography>
        )}
      </Grid>
      <Grid item>
        <DateRange
          onClick={() => onOpenChange(!state.open)}
          color="secondary"
          className={classes.hover}
        />
      </Grid>
      <Grid item>
        <DatePicker
          onOpenChange={onOpenChange}
          open={state.open}
          animation="slide-up"
          calendar={calendar}
          value={state.value}
          onChange={onChange}
        >
          {({ value }) => {
            return (
              <TextField
                placeholder="Select a week "
                variant="outlined"
                margin="dense"
                type="text"
                fullWidth
                value={(value && `Week ${value.format(format)}`) || ""}
              />
            );
          }}
        </DatePicker>
      </Grid>
    </Grid>
  );
}

export default CalendarComponent;
